import { subDays, subHours, subMinutes } from "date-fns"
import { Terminal } from "@features/in-stores/types/terminal.types"

export const mockTerminals: Terminal[] = [
  {
    id: "tmr_1234567890",
    name: "Main Checkout Terminal",
    tid: "TID001234",
    status: "active",
    location: {
      name: "Downtown Store",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Downtown Store SF",
    lastSeen: subMinutes(new Date(), 5).toISOString(),
    createdAt: subDays(new Date(), 30).toISOString(),
    lastUpdated: subDays(new Date(), 1).toISOString(),
    ltv: 125000,
    blocked: false
  },
  {
    id: "tmr_2345678901",
    name: "Mobile Payment Terminal",
    tid: "TID002345",
    status: "active",
    location: {
      name: "Food Truck",
      city: "Oakland",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Mobile",
    store: "Oakland Food Truck",
    lastSeen: subMinutes(new Date(), 2).toISOString(),
    createdAt: subDays(new Date(), 45).toISOString(),
    lastUpdated: subHours(new Date(), 2).toISOString(),
    ltv: 85000,
    blocked: false
  },
  {
    id: "tmr_3456789012",
    name: "Checkout Terminal 2",
    tid: "TID003456",
    status: "offline",
    location: {
      name: "Westfield Mall",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Westfield Mall",
    lastSeen: subHours(new Date(), 3).toISOString(),
    createdAt: subDays(new Date(), 60).toISOString(),
    lastUpdated: subHours(new Date(), 3).toISOString(),
    ltv: 67500,
    blocked: false
  },
  {
    id: "tmr_4567890123",
    name: "Pop-up Stand Terminal",
    tid: "TID004567",
    status: "blocked",
    location: {
      name: "Farmers Market",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Portable",
    store: "Farmers Market Stand",
    lastSeen: subHours(new Date(), 1).toISOString(),
    createdAt: subDays(new Date(), 15).toISOString(),
    lastUpdated: subHours(new Date(), 1).toISOString(),
    ltv: 32000,
    blocked: true
  },
  {
    id: "tmr_5678901234",
    name: "Backup Terminal",
    tid: "TID005678",
    status: "inactive",
    location: {
      name: "Storage Room",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Handheld",
    store: "Downtown Store SF",
    lastSeen: subDays(new Date(), 2).toISOString(),
    createdAt: subDays(new Date(), 90).toISOString(),
    lastUpdated: subDays(new Date(), 2).toISOString(),
    ltv: 15000,
    blocked: false
  },
  {
    id: "tmr_6789012345",
    name: "Drive-thru Terminal",
    tid: "TID006789",
    status: "active",
    location: {
      name: "Coffee Shop Drive-thru",
      city: "Oakland",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Fixed",
    store: "Coffee Shop Oakland",
    lastSeen: subMinutes(new Date(), 1).toISOString(),
    createdAt: subDays(new Date(), 20).toISOString(),
    lastUpdated: subMinutes(new Date(), 30).toISOString(),
    ltv: 95000,
    blocked: false
  },
  {
    id: "tmr_7890123456",
    name: "Kiosk Terminal A",
    tid: "TID007890",
    status: "active",
    location: {
      name: "Airport Terminal 1",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Kiosk",
    store: "SFO Terminal 1",
    lastSeen: subMinutes(new Date(), 3).toISOString(),
    createdAt: subDays(new Date(), 120).toISOString(),
    lastUpdated: subHours(new Date(), 1).toISOString(),
    ltv: 280000,
    blocked: false
  },
  {
    id: "tmr_8901234567",
    name: "Delivery Terminal",
    tid: "TID008901",
    status: "offline",
    location: {
      name: "Delivery Van #3",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Mobile",
    store: "Delivery Fleet SF",
    lastSeen: subHours(new Date(), 6).toISOString(),
    createdAt: subDays(new Date(), 35).toISOString(),
    lastUpdated: subHours(new Date(), 6).toISOString(),
    ltv: 45000,
    blocked: true
  },
  {
    id: "tmr_9012345678",
    name: "Restaurant POS 1",
    tid: "TID009012",
    status: "active",
    location: {
      name: "Italian Bistro",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Italian Bistro SF",
    lastSeen: subMinutes(new Date(), 8).toISOString(),
    createdAt: subDays(new Date(), 75).toISOString(),
    lastUpdated: subHours(new Date(), 4).toISOString(),
    ltv: 180000,
    blocked: false
  },
  {
    id: "tmr_0123456789",
    name: "Retail Terminal B",
    tid: "TID010123",
    status: "active",
    location: {
      name: "Fashion Store",
      city: "Oakland",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Handheld",
    store: "Fashion Store Oakland",
    lastSeen: subMinutes(new Date(), 12).toISOString(),
    createdAt: subDays(new Date(), 55).toISOString(),
    lastUpdated: subHours(new Date(), 3).toISOString(),
    ltv: 92000,
    blocked: false
  },
  {
    id: "tmr_1234567890a",
    name: "Gas Station Terminal",
    tid: "TID011234",
    status: "inactive",
    location: {
      name: "Shell Station",
      city: "San Jose",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Fixed",
    store: "Shell Station SJ",
    lastSeen: subDays(new Date(), 1).toISOString(),
    createdAt: subDays(new Date(), 180).toISOString(),
    lastUpdated: subDays(new Date(), 1).toISOString(),
    ltv: 340000,
    blocked: false
  },
  {
    id: "tmr_2345678901a",
    name: "Pharmacy Terminal",
    tid: "TID012345",
    status: "active",
    location: {
      name: "City Pharmacy",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "City Pharmacy SF",
    lastSeen: subMinutes(new Date(), 15).toISOString(),
    createdAt: subDays(new Date(), 110).toISOString(),
    lastUpdated: subHours(new Date(), 2).toISOString(),
    ltv: 225000,
    blocked: false
  },
  {
    id: "tmr_3456789012a",
    name: "Grocery Checkout 1",
    tid: "TID013456",
    status: "blocked",
    location: {
      name: "Fresh Market",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Countertop",
    store: "Fresh Market SF",
    lastSeen: subHours(new Date(), 2).toISOString(),
    createdAt: subDays(new Date(), 85).toISOString(),
    lastUpdated: subHours(new Date(), 2).toISOString(),
    ltv: 156000,
    blocked: true
  },
  {
    id: "tmr_4567890123a",
    name: "Hotel Lobby Terminal",
    tid: "TID014567",
    status: "active",
    location: {
      name: "Grand Hotel",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Portable",
    store: "Grand Hotel SF",
    lastSeen: subMinutes(new Date(), 7).toISOString(),
    createdAt: subDays(new Date(), 200).toISOString(),
    lastUpdated: subMinutes(new Date(), 45).toISOString(),
    ltv: 410000,
    blocked: false
  },
  {
    id: "tmr_5678901234a",
    name: "Bookstore Terminal",
    tid: "TID015678",
    status: "inactive",
    location: {
      name: "Corner Bookstore",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Corner Bookstore SF",
    lastSeen: subHours(new Date(), 8).toISOString(),
    createdAt: subDays(new Date(), 95).toISOString(),
    lastUpdated: subHours(new Date(), 8).toISOString(),
    ltv: 35000,
    blocked: false
  },
  {
    id: "tmr_6789012345a",
    name: "Salon Terminal",
    tid: "TID016789",
    status: "active",
    location: {
      name: "Beauty Salon",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Mobile",
    store: "Beauty Salon SF",
    lastSeen: subMinutes(new Date(), 18).toISOString(),
    createdAt: subDays(new Date(), 40).toISOString(),
    lastUpdated: subHours(new Date(), 1).toISOString(),
    ltv: 68000,
    blocked: false
  },
  {
    id: "tmr_7890123456a",
    name: "Gym Reception Terminal",
    tid: "TID017890",
    status: "offline",
    location: {
      name: "Fitness Center",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Fixed",
    store: "Fitness Center SF",
    lastSeen: subDays(new Date(), 3).toISOString(),
    createdAt: subDays(new Date(), 125).toISOString(),
    lastUpdated: subDays(new Date(), 3).toISOString(),
    ltv: 190000,
    blocked: false
  },
  {
    id: "tmr_8901234567a",
    name: "Mall Kiosk B",
    tid: "TID018901",
    status: "active",
    location: {
      name: "Shopping Mall",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Kiosk",
    store: "Mall Kiosk SF",
    lastSeen: subMinutes(new Date(), 4).toISOString(),
    createdAt: subDays(new Date(), 65).toISOString(),
    lastUpdated: subHours(new Date(), 6).toISOString(),
    ltv: 145000,
    blocked: false
  },
  {
    id: "tmr_9012345678a",
    name: "Car Wash Terminal",
    tid: "TID019012",
    status: "blocked",
    location: {
      name: "Auto Wash",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Fixed",
    store: "Auto Wash SF",
    lastSeen: subHours(new Date(), 5).toISOString(),
    createdAt: subDays(new Date(), 150).toISOString(),
    lastUpdated: subHours(new Date(), 5).toISOString(),
    ltv: 89000,
    blocked: true
  },
  {
    id: "tmr_0123456789a",
    name: "Bakery Terminal",
    tid: "TID020123",
    status: "active",
    location: {
      name: "Corner Bakery",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Countertop",
    store: "Corner Bakery SF",
    lastSeen: subMinutes(new Date(), 6).toISOString(),
    createdAt: subDays(new Date(), 25).toISOString(),
    lastUpdated: subMinutes(new Date(), 20).toISOString(),
    ltv: 42000,
    blocked: false
  },
  {
    id: "tmr_1234567890b",
    name: "Laundromat Terminal",
    tid: "TID021234",
    status: "inactive",
    location: {
      name: "Wash & Dry",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Fixed",
    store: "Wash & Dry SF",
    lastSeen: subHours(new Date(), 12).toISOString(),
    createdAt: subDays(new Date(), 160).toISOString(),
    lastUpdated: subHours(new Date(), 12).toISOString(),
    ltv: 75000,
    blocked: false
  },
  {
    id: "tmr_2345678901b",
    name: "Pet Store Terminal",
    tid: "TID022345",
    status: "active",
    location: {
      name: "Pet Paradise",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Handheld",
    store: "Pet Paradise SF",
    lastSeen: subMinutes(new Date(), 9).toISOString(),
    createdAt: subDays(new Date(), 70).toISOString(),
    lastUpdated: subHours(new Date(), 5).toISOString(),
    ltv: 58000,
    blocked: false
  },
  {
    id: "tmr_3456789012b",
    name: "Hardware Store Terminal",
    tid: "TID023456",
    status: "active",
    location: {
      name: "Tools & More",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Tools & More SF",
    lastSeen: subMinutes(new Date(), 11).toISOString(),
    createdAt: subDays(new Date(), 140).toISOString(),
    lastUpdated: subHours(new Date(), 7).toISOString(),
    ltv: 165000,
    blocked: false
  },
  {
    id: "tmr_4567890123b",
    name: "Food Truck Terminal 2",
    tid: "TID024567",
    status: "offline",
    location: {
      name: "Taco Truck",
      city: "Oakland",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Mobile",
    store: "Taco Truck Oakland",
    lastSeen: subDays(new Date(), 1).toISOString(),
    createdAt: subDays(new Date(), 30).toISOString(),
    lastUpdated: subDays(new Date(), 1).toISOString(),
    ltv: 52000,
    blocked: false
  },
  {
    id: "tmr_5678901234b",
    name: "Florist Terminal",
    tid: "TID025678",
    status: "active",
    location: {
      name: "Flower Shop",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Portable",
    store: "Flower Shop SF",
    lastSeen: subMinutes(new Date(), 14).toISOString(),
    createdAt: subDays(new Date(), 45).toISOString(),
    lastUpdated: subHours(new Date(), 3).toISOString(),
    ltv: 38000,
    blocked: false
  },
  {
    id: "tmr_6789012345b",
    name: "Jewelry Store Terminal",
    tid: "TID026789",
    status: "blocked",
    location: {
      name: "Diamond Palace",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Handheld",
    store: "Diamond Palace SF",
    lastSeen: subHours(new Date(), 4).toISOString(),
    createdAt: subDays(new Date(), 220).toISOString(),
    lastUpdated: subHours(new Date(), 4).toISOString(),
    ltv: 520000,
    blocked: true
  },
  {
    id: "tmr_7890123456b",
    name: "Optical Store Terminal",
    tid: "TID027890",
    status: "active",
    location: {
      name: "Vision Center",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Vision Center SF",
    lastSeen: subMinutes(new Date(), 3).toISOString(),
    createdAt: subDays(new Date(), 105).toISOString(),
    lastUpdated: subMinutes(new Date(), 35).toISOString(),
    ltv: 175000,
    blocked: false
  },
  {
    id: "tmr_8901234567b",
    name: "Electronics Store Terminal",
    tid: "TID028901",
    status: "offline",
    location: {
      name: "Tech Hub",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Countertop",
    store: "Tech Hub SF",
    lastSeen: subHours(new Date(), 9).toISOString(),
    createdAt: subDays(new Date(), 80).toISOString(),
    lastUpdated: subHours(new Date(), 9).toISOString(),
    ltv: 285000,
    blocked: false
  },
  {
    id: "tmr_9012345678b",
    name: "Shoe Store Terminal",
    tid: "TID029012",
    status: "active",
    location: {
      name: "Footwear Plus",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Fixed",
    store: "Footwear Plus SF",
    lastSeen: subMinutes(new Date(), 16).toISOString(),
    createdAt: subDays(new Date(), 190).toISOString(),
    lastUpdated: subHours(new Date(), 2).toISOString(),
    ltv: 210000,
    blocked: false
  },
  {
    id: "tmr_0123456789b",
    name: "Toy Store Terminal",
    tid: "TID030123",
    status: "offline",
    location: {
      name: "Kids Paradise",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Portable",
    store: "Kids Paradise SF",
    lastSeen: subDays(new Date(), 2).toISOString(),
    createdAt: subDays(new Date(), 50).toISOString(),
    lastUpdated: subDays(new Date(), 2).toISOString(),
    ltv: 95000,
    blocked: false
  },
  {
    id: "tmr_1234567890c",
    name: "Sporting Goods Terminal",
    tid: "TID031234",
    status: "active",
    location: {
      name: "Sports World",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Sports World SF",
    lastSeen: subMinutes(new Date(), 5).toISOString(),
    createdAt: subDays(new Date(), 135).toISOString(),
    lastUpdated: subHours(new Date(), 4).toISOString(),
    ltv: 195000,
    blocked: false
  },
  {
    id: "tmr_2345678901c",
    name: "Music Store Terminal",
    tid: "TID032345",
    status: "blocked",
    location: {
      name: "Melody Shop",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Square Terminal",
    type: "Mobile",
    store: "Melody Shop SF",
    lastSeen: subHours(new Date(), 7).toISOString(),
    createdAt: subDays(new Date(), 90).toISOString(),
    lastUpdated: subHours(new Date(), 7).toISOString(),
    ltv: 72000,
    blocked: true
  },
  {
    id: "tmr_3456789012c",
    name: "Art Gallery Terminal",
    tid: "TID033456",
    status: "active",
    location: {
      name: "Gallery Modern",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "BBPOS Chipper 2X BT",
    type: "Handheld",
    store: "Gallery Modern SF",
    lastSeen: subMinutes(new Date(), 2).toISOString(),
    createdAt: subDays(new Date(), 165).toISOString(),
    lastUpdated: subMinutes(new Date(), 25).toISOString(),
    ltv: 385000,
    blocked: false
  },
  {
    id: "tmr_4567890123c",
    name: "Antique Shop Terminal",
    tid: "TID034567",
    status: "offline",
    location: {
      name: "Vintage Finds",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Stripe Reader S700",
    type: "Portable",
    store: "Vintage Finds SF",
    lastSeen: subHours(new Date(), 15).toISOString(),
    createdAt: subDays(new Date(), 250).toISOString(),
    lastUpdated: subHours(new Date(), 15).toISOString(),
    ltv: 125000,
    blocked: false
  },
  {
    id: "tmr_5678901234c",
    name: "Wine Shop Terminal",
    tid: "TID035678",
    status: "active",
    location: {
      name: "Vine & Dine",
      city: "San Francisco",
      state: "CA",
      country: "USA"
    },
    model: "Verifone P400",
    type: "Countertop",
    store: "Vine & Dine SF",
    lastSeen: subMinutes(new Date(), 1).toISOString(),
    createdAt: subDays(new Date(), 120).toISOString(),
    lastUpdated: subMinutes(new Date(), 10).toISOString(),
    ltv: 245000,
    blocked: false
  }
]
